export const config = {
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
}

if(!process.env.REACT_APP_API_ENDPOINT) {throw new Error('process.env.REACT_APP_API_ENDPOINT is missing!')}
